import { DictionaryNum } from '@ngrx/entity/src/models';
import { BusinessDescription } from './business-description.model';
import { CompanyInfo } from './company-info.model';
import { FinancialDetailsById } from './financial-details-by-id.model';
import { Financial } from './financial.model';
import { ShareHolder } from './share-holder.model';
import { Subsidiary } from './subsidiary.model';

export class Comparable {
  comparableId: number;
  databaseId: number;
  groupLinkId: number;
  companyName: string;

  databases: number[];
  companyInfo: DictionaryNum<CompanyInfo>; // dictionarynum is to hold multi db data
  industryDescriptions: DictionaryNum<string[]>;
  businessDescriptions: DictionaryNum<BusinessDescription>;
  subsidiaries: Subsidiary[];
  shareHolders: ShareHolder[];
  financialData: FinancialDetailsById<Financial>;

  hasDrillDownDetailsLoaded: boolean;
  studyComparable: boolean;
}
